;(function(window, $)
{
	function SendFeedBack(options)
	{
		this.options = options || {};
		this.initEvent(this.options);
	}

	SendFeedBack.prototype.initEvent = function(options)
	{
		var args = {};
		if(options.btnId)
		{
			$('#' + options.btnId).click(function()
			{
				var reportName = "",
						reportEmail = "",
						reportDescription = "",
						regEmail = ""
						$btn = options.btnId,
						$name = options.nameId,
						$email = options.emailId,
						$desc = options.descId;
				if($name)
				{
					reportName = $.trim($('#' + $name).val());
					$('#' + $name).next().remove();
					if(reportName == "")
					{
						$('#' + $name).after('<span class="empty">' + NEU.util.getLocalizedString("report_form_name_empty") + '</span>');
					}
				}
				if($email)
				{
					reportEmail = $.trim($('#' + $email).val());
					regEmail = /(^[a-zA-Z0-9]([a-zA-Z0-9_\-\~\.\!\#\&\'\+\=\^\`\|]*)@([a-zA-Z0-9_\-\.]*)([.][a-zA-Z]{3,24})$)|(^[a-zA-Z0-9]([a-zA-Z0-9_\-\~\.\!\#\&\'\+\=\^\`\|]*)@([a-zA-Z0-9_\-\.]*)(\.[a-zA-Z]{2,4})(\.[a-zA_Z]{2})*$)/i;
					$('#' + $email).next().remove();
					if(reportEmail == "")
					{
						$('#' + $email).after('<span class="empty">' + NEU.util.getLocalizedString("report_form_email_empty") + '</span>');
					}
					else if(reportEmail != "" && !regEmail.test(reportEmail))
					{
						$('#' + $email).after('<span class="empty error">' + NEU.util.getLocalizedString("report_form_email_error") + '</span>');
					}
				}
				if($desc)
				{
					reportDescription = $.trim($('#' + $desc).val());
					if(reportDescription == "")
					{
						$('#' + $desc).next().remove();
						$('#' + $desc).after('<span class="empty">' + NEU.util.getLocalizedString("report_form_desc_empty") + '</span>');
					}
				}
				if(reportName && reportEmail && regEmail.test(reportEmail) && reportDescription)
				{
					args.name = reportName;
					args.email = reportEmail;
					args.desc = reportDescription;
					args.site = config.SITE_ID;
					$.ajax({
						type: "POST",
						url: config.LOC_SERVER + "elevensportsv2/mailsender.jsp",
						data: args,
						success: function (data)
						{
							$('#' + $desc).next().remove();
							if(data.code == "200")
							{
								$('#' + $desc).after('<span class="success">' + NEU.util.getLocalizedString("report_form_success") + '</span>');
							}
							else if(data.code == "500")
							{
								$('#' + $desc).after('<span class="empty">' + NEU.util.getLocalizedString("report_form_error") + '</span>');
							}
						},
						dataType: "json"
					});
				}
			});
		}
	}
	window.SendFeedBack = SendFeedBack;

})(window, jQuery);